import asyncComponent from '../../components/AsyncComponent';

const AsyncWorkflow = asyncComponent(() => import('../../containers/Workflow/WorkflowList'));

export default AsyncWorkflow;
